import { gql } from 'apollo-angular';

export const GET_INVOICE_AGING_REPORT = gql`
  query fetchAgingReportInvoice($filters: FetchReportQueryDto!) {
    fetchAgingReportInvoice(filters: $filters) {
      id
      invoiceDetails {
        invoiceNo
        dueDate
        balance
        customerData {
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_VENDOR_INVOICE_AGING_REPORT = gql`
  query fetchAgingReportVendorInvoice($filters: FetchReportQueryDto!) {
    fetchAgingReportVendorInvoice(filters: $filters) {
      billDetails {
        dueDate
        billNo
        balance
        vendorData {
          vendorName
        }
      }
    }
  }
`;

export const GET_GENERAL_LEDGER_REPORT = gql`
  query fetchGeneralLedgerReport($filters: FetchReportQueryDto!) {
    fetchGeneralLedgerReport(filters: $filters) {
      id
      journalData {
        id
        journalNo
        refType
      }
      accountData {
        accountType
        accountName
      }
      debit
      credit
    }
  }
`;

export const GET_ACCOUNT_LEDGER_REPORT = gql`
  query generalLedgerReport(
    $startDate: String
    $endDate: String
    $accountId: Float
  ) {
    generalLedgerReport(
      startDate: $startDate
      endDate: $endDate
      accountId: $accountId
    ) {
      accountName
      accountType
      totalDebit
      totalCredit
      transactions {
        date
        reference
        debit
        credit
      }
    }
  }
`;

export const GET_JOURNAL_REPORT = gql`
  query journalReport($startDate: String, $endDate: String) {
    journalReport(startDate: $startDate, endDate: $endDate) {
      journalNo
      reference
      date
      journalEntries {
        accountData {
          accountName
          accountType
        }
        debit
        credit
      }
    }
  }
`;

export const GET_VAT_REPORT = gql`
  query vatReport($startDate: String, $endDate: String) {
    vatReport(startDate: $startDate, endDate: $endDate) {
      totalVatPayable
      vatPayable {
        accountName
        refType
        reference
        date
        totalDebit
        totalCredit
        netAmount
      }
      totalVatReceivable
      vatReceivable {
        accountName
        refType
        reference
        date
        totalDebit
        totalCredit
        netAmount
      }
    }
  }
`;

export const GET_BALANCE_SHEET_REPORT = gql`
  query balanceSheetReport($startDate: String, $endDate: String) {
    balanceSheetReport(startDate: $startDate, endDate: $endDate) {
      totalAssets
      assets {
        accountName
        accountType
        totalDebit
        totalCredit
        netAmount
      }
      totalLiabilities
      liabilities {
        accountName
        accountType
        totalDebit
        totalCredit
        netAmount
      }
      totalEquity
      equity {
        accountName
        accountType
        totalDebit
        totalCredit
        netAmount
      }
    }
  }
`;

export const GET_PROFIT_LOSS_REPORT = gql`
  query profitLossReport($startDate: String, $endDate: String) {
    profitLossReport(startDate: $startDate, endDate: $endDate) {
      totalIncome
      totalExpense
      netProfit
      income {
        accountId
        accountName
        accountType
        totalCredit
        totalDebit
        netAmount
      }
      expense {
        accountId
        accountName
        accountType
        totalCredit
        totalDebit
        netAmount
      }
    }
  }
`;

export const TRIAL_BALANCE_REPORT = gql`
  query trialBalanceReport($startDate: String!, $endDate: String!) {
    trialBalanceReport(startDate: $startDate, endDate: $endDate) {
      accounts {
        accountName
        accountType
        totalDebit
        totalCredit
        netAmount
      }
      totalDebit
      totalCredit
    }
  }
`;

export const GET_DAY_BOOK_REPORT = gql`
  query dayBookReport($date: String!) {
    dayBookReport(date: $date) {
      entries {
        date
        journalNo
        reference
        accountName
        accountType
        debit
        credit
        description
      }
      totalDebit
      totalCredit
    }
  }
`;

export const GET_BALANCE_SUMMARY_REPORT = gql`
  query balanceSummary($data: BalanceSummaryInput!) {
    balanceSummary(data: $data) {
      partnerType
      name
      totalAmount
      pendingAmount
    }
  }
`;

export const MOVEMENT_TRIAL_BALANCE_REPORT = gql`
  query movementTrialBalanceReport($startDate: String!, $endDate: String) {
    movementTrialBalanceReport(startDate: $startDate, endDate: $endDate) {
      accounts {
        accountName
        accountType
        openingDebit
        openingCredit
        periodDebit
        periodCredit
        closingDebit
        closingCredit
      }
      totalOpeningDebit
      totalOpeningCredit
      totalPeriodDebit
      totalPeriodCredit
      totalClosingDebit
      totalClosingCredit
    }
  }
`;

//check the below

export const GET_CASH_FLOW_REPORT = gql`
  query cashFlowStatement($startDate: DateTime!, $endDate: DateTime!) {
    cashFlowStatement(startDate: $startDate, endDate: $endDate) {
      beginningCashBalance
      operatingActivities {
        total
        details {
          accountName
          amount
        }
      }
      investingActivities {
        total
        details {
          accountName
          amount
        }
      }
      financingActivities {
        total
        details {
          accountName
          amount
        }
      }
      netChangeInCash
      endingCashBalance
    }
  }
`;

export const GET_SALES_BY_ITEM_REPORT = gql`
  query salesByItem($startDate: String, $endDate: String) {
    salesByItem(startDate: $startDate, endDate: $endDate) {
      items {
        itemName
        skuCode
        quantitySold
        amount
        averagePrice
      }
      totalQuantity
      totalAmount
    }
  }
`;

export const GET_SALES_BY_CUSTOMER_REPOTT = gql`
  query salesByCustomer($startDate: String, $endDate: String) {
    salesByCustomer(startDate: $startDate, endDate: $endDate) {
      salesByCustomer {
        partnerId
        partnerName
        totalSales
        totalInvoices
      }

      totalInvoiceCount
      totalSalesAmount
    }
  }
`;

export const GET_ACCOUNT_TYPE_SUMMARY = gql`
  query getAccountTypesSummary(
    $branchId: Int
    $startDate: String
    $endDate: String
  ) {
    getAccountTypesSummary(
      branchId: $branchId
      startDate: $startDate
      endDate: $endDate
    ) {
      accountTypeSummary {
        groupName
        groupNameFormatted
        accountsList {
          accountType
          accountCode
          accountTypeFormatted
          accountTypeId
          debit
          debitFormatted
          credit
          creditFormatted
          values {
            debit
            credit
            debitFormatted
            creditFormatted
          }
        }
      }
      id
      accountType
      debit
      credit
      reportType
      fromDateFormatted
      toDateFormatted
    }
  }
`;

export const VENDOR_BALANCE_SUMMARY_REPORT = gql`
  query getVendorBalanceSummary($startDate: String!, $endDate: String!) {
    getVendorBalanceSummary(startDate: $startDate, endDate: $endDate) {
      summary {
        vendorName
        billedAmount
        amountPaid
        closingBalance
      }
      totals {
        totalBilledAmount
        totalAmountPaid
        totalClosingBalance
      }
    }
  }
`;

export const GET_COST_REPORT = gql`
  query getProjectReport(
    $projectId: Float!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    getProjectReport(
      projectId: $projectId
      startDate: $startDate
      endDate: $endDate
    ) {
      project {
        projectName
        projectCode
        projectDescription
        totalProjectCost
        startDate
        endDate
        threshold
      }
      transaction {
        partyName
        orderNumber
        type
        date
        description
        amount
        paidReceivedAmount
        balance
        referenceNumber
      }
    }
  }
`;
